import { motion } from "framer-motion";
import { ShieldCheck, Zap, RefreshCcw } from "lucide-react";
import { LANDING } from "@/constants/testIds";

// Exactly three benefits, each an icon + one short sentence. Deliberately
// spacious — top marketplaces avoid feature grids in favour of a single row
// with breathing room on every side.
const BENEFITS = [
  {
    icon: ShieldCheck,
    title: "Verified coaches",
    line: "Every coach is background-checked and reviewed by real clients.",
  },
  {
    icon: Zap,
    title: "Book in seconds",
    line: "Pick a time, pay securely, done — no messaging back and forth.",
  },
  {
    icon: RefreshCcw,
    title: "Money-back guarantee",
    line: "If your first session isn't right, we refund it. No questions asked.",
  },
];

export default function Benefits() {
  return (
    <section
      id="benefits"
      data-testid={LANDING.benefits}
      className="py-24 md:py-32 border-t border-slate-100"
    >
      <div className="max-w-[1120px] mx-auto px-6 md:px-10">
        <ul className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            return (
              <motion.li
                key={b.title}
                data-testid={LANDING.benefitItem(i)}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className="text-center md:text-left"
              >
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-900 text-white">
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </div>
                <h3 className="mt-6 font-display text-xl md:text-2xl tracking-tight text-slate-900">
                  {b.title}
                </h3>
                <p className="mt-3 font-body text-slate-500 text-[15px] leading-relaxed max-w-[36ch] mx-auto md:mx-0">
                  {b.line}
                </p>
              </motion.li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
